import { environment } from 'environments/environment';

export class KeycloakUtils {
  static getKeycloakClientId(): string {
    const url: string = window.location.origin;
    switch (url) {
      case environment.sparkasseUrl:
        return environment.keycloak.sparkasseClientId;
      case environment.enercityUrl:
        return environment.keycloak.enercityClientId;
      case environment.kommaUrl:
        return environment.keycloak.komma;
      default:
        return environment.keycloak.clientId;
    }
  }

  /**
   * Current URL without fragment. The fragment may contain a previous OIDC callback.
   */
  static getRedirectUri(): string {
    return window.location.href.split('#')[0];
  }
}
